export default __webpack_public_path__ + "static/site-7e91398d19b20db46cc99fcd922070df.png";